'use client';

import { MotionConfig } from 'motion/react';
import type { ReactNode } from 'react';

/**
 * Azaltılmış hareket ayarının tek kurulum noktası — DESIGN.md §5.
 *
 * `reducedMotion="user"` işletim sistemi tercihine uyar: konum ve ölçek
 * animasyonlarını kapatır, opaklığı bırakır. Kök layout sunucu bileşeni
 * olduğu için bu ince istemci sarmalayıcısı gerekiyor.
 *
 * Parallax, sonsuz döngü gibi ağır efektlerde bu YETMEZ; oralarda ayrıca
 * `useReducedMotion()` ile elle kontrol edilir.
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
